module.exports = __webpack_public_path__ + "img/Group 6853@2x.30697d4b.png";